import type { RouteRecordRaw } from 'vue-router/auto'
import { Modules } from '@/types/generated'
import Role = Modules.Shared.Enums.RoleEnum
import UserData = Modules.User.AuthData

// 👉 Redirects
export const redirects: RouteRecordRaw[] = [
  // ℹ️ We are redirecting to different pages based on role.
  // NOTE: Role is just for UI purposes. ACL is based on abilities.
  {
    path: '/',
    name: 'index',
    redirect: to => {
      const userData = useCookie<UserData>('userData')
      const userRoles: string [] = userData.value?.roles ?? []

      if (!!(userData?.value) && !userData.value?.isEmailVerified)
        return { name: 'verify-email' }
      if (userRoles.includes(Role.ADMIN))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.MANAGER))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.EXPERT))
        return { name: 'dashboards-expert' }
      if (userRoles.includes(Role.LEAD_EXPERT))
        return { name: 'dashboards-expert' }
      if (userRoles.includes(Role.HEAD))
        return { name: 'dashboards-head' }
      if (userRoles.includes(Role.SCOPED_ADMIN))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.PLAYER))
        return { name: 'dashboards-player' }

      return { name: 'login', query: to.query }
    },
  },
  {
    path: '/pages/user-profile',
    name: 'pages-user-profile',
    redirect: () => ({ name: 'pages-user-profile-tab', params: { tab: 'profile' } }),
  },
  {
    path: '/api/games/join-failed/:token',
    name: 'join-failed',
    redirect: to => {
      const userData = useCookie<UserData>('userData')
      const systemErrors = useCookie<any>('systemErrors')
      const userRoles: string [] = userData.value?.roles ?? []

      if (systemErrors.value !== undefined)
        systemErrors.value.showContactSupportErrorMessage = true
      else
        systemErrors.value = { showContactSupportErrorMessage: true }

      if (!!(userData?.value) && !userData.value?.isEmailVerified)
        return { name: 'verify-email' }
      if (userRoles.includes(Role.ADMIN))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.MANAGER))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.EXPERT))
        return { name: 'dashboards-expert' }
      if (userRoles.includes(Role.LEAD_EXPERT))
        return { name: 'dashboards-expert' }
      if (userRoles.includes(Role.HEAD))
        return { name: 'dashboards-head' }
      if (userRoles.includes(Role.SCOPED_ADMIN))
        return { name: 'dashboards-manager' }
      if (userRoles.includes(Role.PLAYER))
        return { name: 'dashboards-player' }

      return { name: 'login', query: to.query }
    },
  },
  {
    path: '/api/auth/login',
    name: 'verify-login',
    redirect: () => ({ name: 'login' }),
  },
  {
    path: '/account-settings',
    name: 'account-settings',
    redirect: () => ({ name: 'account-settings-tab', params: { tab: 'account' } }),
  },
]

export const routes: RouteRecordRaw[] = [
]
